





















import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import ChangeLogListBase from "./ChangeLogListBase";

@Component
export default class ChangeLogList extends ChangeLogListBase {

	created() {
		this.isBusy = true;
		super.initializeRights(undefined, undefined, 'COR_ChangeLog_Read', 'COR_ChangeLog_Update');
		super.created();
		super.setDetailName('ChangeLogDetail');
	};


	// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
	loadFilters(value: any) { super.loadFilters(value); };
	createNewClick(elementId: any) { super.createNewClick(elementId); }
	detailClick(elementId: any) { super.detailClick(elementId); };		
	deleteClick(elementId: any) { super.deleteClick(elementId); };

};
